<script setup lang="ts">
import CheckIcon from '@/assets/icons/CheckIcon.vue';
import CustomCheckbox from '@/core/elements/CustomCheckbox.vue';
import { computed } from 'vue';

defineOptions({ name: 'SelectionPopoverOptionRow' });

const emit = defineEmits<{
  select: [];
}>();

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    highlightOffset?: boolean;
    selected: boolean;
    subtleSelection?: boolean;
    indicator?: 'check' | 'checkbox';
  }>(),
  { disabled: false, highlightOffset: false, indicator: 'check', subtleSelection: false },
);
const highlighted = computed(() => props.selected && !props.subtleSelection);
</script>

<template>
  <button
    type="button"
    class="popover-option disabled:cursor-default"
    :class="highlighted && 'bg-highlight'"
    :disabled="props.disabled"
    :role="props.indicator === 'checkbox' ? 'checkbox' : undefined"
    :aria-checked="props.indicator === 'checkbox' ? props.selected : undefined"
    :aria-pressed="props.indicator === 'check' ? props.selected : undefined"
    @click="emit('select')"
  >
    <slot name="leading" :selected="props.selected" />
    <span
      class="min-w-0 flex-1 truncate text-body"
      :class="[props.highlightOffset && 'highlight-offset', highlighted ? 'font-semibold text-tint' : 'text-primary']"
    >
      <slot />
    </span>
    <CheckIcon v-if="props.indicator === 'check' && props.selected" class="size-icon-md shrink-0 text-tint" />
    <CustomCheckbox
      v-else-if="props.indicator === 'checkbox'"
      :model-value="props.selected"
      :subtle="props.subtleSelection"
      readonly
      aria-hidden="true"
      class="pointer-events-none"
    />
  </button>
</template>
